import styled from "styled-components"
import { fieldStyles } from "../styles"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

export const StyledField = styled(DatePicker)`
  ${fieldStyles}
`
